module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABKklEQVR4AayQgYaFQBRA9wP3KSkQFJAAAYVAQICSAukTChDmDyKhBEBUEM18wN3u2EHLbOw+HGbuO3PmTR+KogheF+SCXcAD7Nv9FOdFJELhj0QihFX4Jy8MkTeECIaoTDAMA8ZxhL7vQdO030IUQyDwfR/SNAVVVfnesiyglMJ5nmCaJs7wN3TQvcVuoW3bgDF2kwgh0Lbt7TJ00JWGmqbhkud5fI/PWZYF1nUFXdf5LAgC/i/rupaHkHmeIQxDvk6SBMOcoij4LI5j/GbCl4eqqoJ932EYBn6zCOEaZ8dxQJ7nzyHXdfGgFAzatv0cQqZpkoa6rhPec6gsS2koyzJpiP4cOo4jfdbX4uPjsWZiqmYRX2pkWqoWIzDsB/XmFyI0f4Gq9YXpBwBAXsp6ttQFdwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/heika.png
// module id = 509
// module chunks = 1